import { gql } from '@apollo/client';

import { BlockedEmailConnectionFragment } from '../fragments/blockedEmailConnectionFragment.gql';

/**
 * Query to fetch blocked emails list with pagination
 * Used to display email addresses that are blocked from receiving orders
 *
 * @param first - Number of results to fetch
 * @param after - Cursor to fetch results after (for pagination)
 */
export const GetBlockedEmailsQuery = gql`
  query GetBlockedEmails($first: Int, $after: String) {
    blockedEmails(first: $first, after: $after) {
      ...BlockedEmailConnectionFragment
    }
  }
  ${BlockedEmailConnectionFragment}
`;
